export default __webpack_public_path__ + "static/underoutfit-case-study-511167675731a8e44d9b88b76aaa8a59.png";